import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
const SCREEN_HEIGHT = 500;
const HOUR_HEIGHT = SCREEN_HEIGHT / 12;
export default function EventPreview({ event, onClick }) {
  const startOffset =
    (moment(event.startTime).hours() +
      moment(event.startTime).minutes() / 60 -
      8) *
    HOUR_HEIGHT;
  const height =
    (moment(event.endTime).diff(moment(event.startTime)) / 3600000) *
    HOUR_HEIGHT;
  const clickEvent = () => {
    onClick(event);
  };
  const course = useSelector((state) =>
    state.courses.find((c) => c.id === event.courseId)
  );
  return (
    <div
      onClick={clickEvent}
      style={{
        position: "absolute",
        top: `${startOffset}px`,
        height: Math.max(height, 10),
        borderRadius: "3px",
        backgroundColor: course ? course.color : "#DDD",
        boxShadow: "-3px 3px 8px #888888",
        width: "100%",
        cursor: "pointer",
      }}
    >
      <div style={{ textAlign: "center", fontSize: "13px" }}>{event.name}</div>
      <div style={{ textAlign: "center", fontSize: "8px" }}>
        {`${moment(event.startTime).format("hh:mm")} -
          ${moment(event.endTime).format("hh:mm")}`}
      </div>
    </div>
  );
}
